"use client";

import {JSX} from "react";

import SmartImage from "@/shared/ui/smart-image";

import {useSnapshot} from "valtio";

import {type StepperInstance} from "@/shared/models/form/steppers";
import {Typography} from "@/shared/ui/data-display/typography";

import "./styles/stepper-field.scss";

interface StepperFieldProps {
    model: StepperInstance;
    label?: string;
    subtitle?: string;
    icon?: string;
    className?: string;
}

export function StepperField({model, label, subtitle, icon, className}: StepperFieldProps): JSX.Element {
    const snapshot = useSnapshot(model);

    return (
        <div className={`stepper-field ${className || ""}`}>
            <div className="stepper-field__wrapper">
                <div className="stepper-field__header">
                    {icon && <SmartImage src={icon} alt={label || ""} width={17} height={16} className="stepper-field__icon" />}
                    <div className="stepper-field__labels">{label && <Typography as="label">{label}</Typography>}</div>
                </div>

                <div className="stepper-field__controls">
                    <button
                        type="button"
                        onClick={() => model.decrement()}
                        disabled={!snapshot.canDecrement}
                        className="stepper-field__button stepper-field__button--decrement"
                        aria-label="Decrement"
                    >
                        −
                    </button>

                    <input
                        type="number"
                        value={snapshot.value}
                        onChange={(e) => model.setValue(Number(e.target.value))}
                        disabled={snapshot.disabled}
                        className="stepper-field__input"
                        aria-label={label}
                    />

                    <button
                        type="button"
                        onClick={() => model.increment()}
                        disabled={!snapshot.canIncrement}
                        className="stepper-field__button stepper-field__button--increment"
                        aria-label="Increment"
                    >
                        +
                    </button>
                </div>
            </div>
            {subtitle && (
                <Typography as="span" size={12} color="paragraph2">
                    {subtitle}
                </Typography>
            )}
        </div>
    );
}
